import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { publicHelpers } from '../../../../globals/helpers/public-helpers';
import { FontCSS, getJoiTemplate } from '../../../../globals/store/publish.data';
import { LabelToggleBar } from '../label-marker/label-toggle-bar';
import { CommonModule } from '@angular/common';
import { LabelSelectorData } from 'globals/store/dialog.selector.data';

@Component({
    selector: 'label-selector-dialog',
    imports: [DialogWrapperComponent, LabelToggleBar, CommonModule],
    template: `
<dialog-wrapper
  [smallTitle]="true"
  [hideBottom]="false"
  [disabled]="false"
  [giveMeTwenty]="false"
  [dontGiveExtraSpacing]="true"
  [isMobile]="!!data.isMobile"
  [data]="{ position: data.position, dialogRef: dialogRef }"
  [showClose]="false"
  [successLabel]="'APPLY'"
  [dialogTitle]="'Filter'"
  [titleHeight]="40"
  [style.--pagebackground]="template.pagebackground"
  [style.--font]="FontCSS[template.font]"
  [style.--header-font]="FontCSS[template.headerFont]"
  [style.--primary]="template.primary"
  [style.--primaryhover]="template.primaryhover"
  [style.--link]="template.link"
  [style.--contentbg]="template.contentbg"
  [style.--contentbgoutline]="template.contentbgoutline"
  [style.--innercontentbg]="template.innercontentbg"
  [style.--innercontentbgoutline]="template.innercontentbgoutline"
  (close)="cancel()"
  (submit)="cancel()"
>
  <div class="selector-instructions" *ngIf="data.instructions" [innerHTML]="helpers.strWithBreak(data.instructions)"></div>
  <ng-container *ngFor="let group of data.labelGroups">
    <h5 *ngIf="group.name">{{ group.name }}</h5>
    <label-toggle-bar *ngFor="let label of group.labels"
      (toggleLabel)="label.selected = !label.selected"
      [text]="label.label || ''"
      [color]="label.color"
      [selected]="!!label.selected"
    ></label-toggle-bar>
  </ng-container>

</dialog-wrapper>
`,
    styles: [`
    .selector-instructions { border-radius: 6px; color: rgba(0,0,0,0.4); background: rgba(0,67,112,0.07); font-size: 11px; line-height: 14px; padding: 10px; margin-bottom: 10px; max-width: 250px; }
`],
    standalone: true
})
export class LabelSelectorDialog implements OnInit {
  @ViewChild(DialogWrapperComponent, { static: true }) dialogWrapper : DialogWrapperComponent;
  helpers = publicHelpers
  template = getJoiTemplate()
  FontCSS = FontCSS

  constructor(public dialogRef: MatDialogRef<LabelSelectorDialog>,
    @Inject(MAT_DIALOG_DATA) public data: LabelSelectorData,
  ) { 
    if (data.template) this.template = data.template
  }

  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(this.cancel.bind(this))
  }

  cancel() {
    this.dialogRef.close(this.data.labelGroups)
  }
}


